import React,{useState,useEffect} from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
} from "reactstrap";
import TextEditor from "components/editor/TextEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { httpRequest } from "utils/httpRequest";
import { toast } from 'react-toastify';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';

const PrivacyPolicy = () => {

  const { loading, startLoading, stopLoading } = useLoader()
  const [buttonLoading, setButtonLoading] = useState(false);
  // Validation Schema
  const validationSchema = Yup.object().shape({
     policy: Yup.string()
        .required("Terms and conditions are required")
        .test('not-empty-html', 'Privacy Policy is required', function(value) {
          if (!value) return false;
          // Remove HTML tags and check if there's actual content
          const textOnly = value.replace(/<[^>]*>/g, '').trim();
          return textOnly.length > 0;
        })
      
  });

  const formik = useFormik({
    initialValues: {
      policy: ""
    },
    validationSchema,
    onSubmit:async  (values) => {
     formik.setTouched({
     
             policy:true
           });
     
           const errors = await formik.validateForm();
     
           if (Object.keys(errors).length > 0) return false;
     
           setButtonLoading(true)
           try {
             const response = await httpRequest(
               "cms/updatePrivacyPolicy",
               "POST",
               {
                 privacyPolicy: values?.policy,
                 
               },
               {},
               true
             );
             if (response?.code === 200) {
              
               toast.success("Privacy Policy Added Successfully")
               getPrivacyPolicy()
             
     
             }
     
           } catch (error) {
            console.log(error);
           }finally{
            setButtonLoading(false)
           }
    },
  });



  useEffect(()=>{
    getPrivacyPolicy()
  },[])



const getPrivacyPolicy= async ()=>{
  startLoading()
  try {
    const response = await httpRequest(
      "cms/getPrivacyPolicy",
      "GET",
      {},
      {},
      true
    );
    if (response?.code === 200) {
     
      formik.setValues({ policy: response?.data?.privacyPolicy });
    

    }

  } catch (error) {
    console.log(error);
  }finally{
    stopLoading()
  }
}












  return (
    <>
  {loading ? <CircleLoader/> :( <Row className="mt-4 justify-content-center">
      <Col lg="8">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-3">
            <div className="text-muted text-center mt-2 mb-3">
              <small>Privacy Policy</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-4">
            <Form onSubmit={formik.handleSubmit}>
              <FormGroup>
                <Label className="form-control-label">Privacy Policy</Label>
                <TextEditor
                  value={formik.values.policy}
                  onChange={(html) => {
                    formik.setFieldValue("policy", html)
                    formik.setFieldTouched("policy", true, false);
                  }}
                  onBlur={() => formik.setFieldTouched("policy", true)}
                  placeholder="Enter your privacy policy here..."
                  hideImageAndLink={false}
                />
                {formik.touched.policy && formik.errors.policy && (
                  <div className="text-danger small mt-1">
                    {formik.errors.policy}
                  </div>
                )}
              </FormGroup>

               <div className="text-center d-flex align-items-center justify-content-center">
                              <Button  className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                                {buttonLoading ? <span className="button-loader"></span> : "Submit"}
                              </Button>
                              
                            </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>)}
    </>
  );
};

export default PrivacyPolicy;